<div class="w-100 bg-white p-1 py-3 my-2">
  <div class="header d-flex justify-content-between p-2 mx-5 my-2">
    <h5>{{"REQUESTS.Statistics" | translate}}</h5>

      <i (click)="openFilter(filterTemplate)" class="bx bx-filter-alt fs-3 pointer"></i>

    <!-- <ng-select (change)="getStatistics()" class="form-control ng-select-customization" style="width: 200px;"
      [(ngModel)]="filterId">
      <ng-option [value]="item.value" *ngFor="let item of filter">
        {{item.name | translate}}
      </ng-option>
    </ng-select> -->
  </div>



  <div class="row W-100  justify-content-evenly" >
    <owl-carousel-o  [options]="customOptions" >
      <ng-container  *ngFor="let item of statisticTitles">
        <ng-template carouselSlide style="width: 135px !important;height: 125px !important;">
          <div class="card mx-1 my-1 border-0" style="box-shadow: 4px 4px 4px 0px #2129371A;max-width: 230px;">
            <div class="card-title d-flex justify-content-between align-items-center">
              <h5 class="mb-0 fs-6">{{item.value|translate}}</h5>
              <div style="width: 30px;height: 30px;" [style.background-color]="item.bg" class=" px-2 py-1 rounded-3">
                <span class="fs-14" [innerHTML]="iconService[item.name]"></span>
              </div>
            </div>
            <div class="card-body d-flex justify-content-center align-items-center">
              <h4 style="color: #0CE89D" class="mb-0">{{ statistics[item.name]}}</h4>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>



  </div>
</div>

<ng-template #filterTemplate>
  <form [formGroup]="filterForm" (ngSubmit)="onSubmit()">

    <div class="header text-center col-12 d-flex justify-content-between p-2 mx-5 my-2">
      <h5>{{"REQUESTS.Statistics" | translate}}</h5>
    </div>
    <div class="row gap-1 justify-content-around w-100">
      <!-- First row  -->
      <div class="row gap-1 justify-content-around w-100">
        <!-- companies  -->
        <div class="col-lg-3 col-md-4">
          <div class="mb-3">
              <label class="form-label text-capitalize">{{'MENUITEMS.COMPANIES.TEXT'|translate}} <span class="required">*</span></label>
              <ng-select class="form-control ng-select-customization"  *ngIf="_AuthenticationService.checkPermission('ViewCompanies')"
                  (change)="getListOfDepartment($event?.id)" formControlName="companyId"
                  [items]="allUserCompanies" bindLabel="name" bindValue="id"></ng-select>
          </div>
        </div>
      <!-- departments  -->
      <div class="col-lg-3 col-md-4" >
        <div class="mb-3">
            <label class="form-label text-capitalize">{{'GENERAL.DEPARTMENTS' |
                translate}} <span class="required">*</span></label>
            <ng-select class="form-control ng-select-customization"
                *ngIf="_AuthenticationService.checkPermission('ViewDepartments')"
                formControlName="departmentId"
                (change)="getListOfEmps()"
                [items]="listOfDepartment" bindLabel="name" bindValue="id"></ng-select>
        </div>
    </div>
    <!-- Employees  -->
    <div class="col-lg-3 col-md-4 form-group p-2" >
      <div class="mb-3">
        <label for="employeeId">{{"MENUITEMS.EMPLOYEES.EMPLOYEENAME" | translate}}</label>

    <ng-select class="form-control ng-select-customization" *ngIf="_AuthenticationService.checkPermission('ViewDepartments')"
    formControlName="employeeId" placeholder="employeeId"
                    (change)="getListOfEmps()"
                [items]="Emps" bindLabel="name" bindValue="id"></ng-select>
  </div>
     </div>
      </div>
      <!-- Second row  -->
      <div class="row gap-1 justify-content-around">
        <!-- Time Range  -->
        <div class="col-lg-3 col-md-4">
          <div class="mb-3">
            <label class="form-label text-capitalize">{{'GENERAL.TIMERANGE'|translate}} <span class="required">*</span></label>
            <ng-select (change)="rangeChanged()" class="form-control ng-select-customization" style="width: 200px;"
            formControlName="timeRange" [clearable]="false" bindValue="value" bindLabel="name" placeholder="timeRange">
            <ng-option [value]="item.value" *ngFor="let item of filter">
              {{item.name | translate}}
            </ng-option>
          </ng-select>

          </div>
      </div>
      <!-- Start date  -->
      <div  class="col-lg-3 col-md-4">
        <div *ngIf="filterForm.get('timeRange').value==null" class="mb-3">
          <label class="form-label text-capitalize">{{'GENERAL.STARTDATE'|translate}}<span class="required">*</span></label>

          <div class="input-group clockpicker">
            <input type="datetime-local" class="form-control" formControlName="startDate"
              placeholder="yyyy-mm-dd">
          </div>
        </div>
    </div>
    <!-- End Date  -->
      <div  class="col-lg-3 col-md-4">
        <div *ngIf="filterForm.get('timeRange').value==null" class="mb-3">
          <label class="form-label text-capitalize">{{'GENERAL.ENDDATE'|translate}} <span class="required">*</span></label>
          <div class="input-group clockpicker">
            <input type="datetime-local" class="form-control" formControlName="endDate"
              placeholder="yyyy-mm-dd">
          </div>
        </div>
    </div>
      </div>

  </div>
  <div class="col-12 text-center p-3">
    <button class="btn btn-dark" type="submit">{{"GENERAL.CONFIRM" | translate}}</button>
   </div>
</form>

</ng-template>`
